__turbopack_context__.v({
  "bookCta": "HowItWorkSection-module__YBUagW__bookCta",
  "dMd": "HowItWorkSection-module__YBUagW__dMd",
  "description": "HowItWorkSection-module__YBUagW__description",
  "phoneImageContainer": "HowItWorkSection-module__YBUagW__phoneImageContainer",
  "progressLine": "HowItWorkSection-module__YBUagW__progressLine",
  "progressShortLine": "HowItWorkSection-module__YBUagW__progressShortLine",
  "root": "HowItWorkSection-module__YBUagW__root",
  "sectionContent": "HowItWorkSection-module__YBUagW__sectionContent",
  "sequenceAnimation": "HowItWorkSection-module__YBUagW__sequenceAnimation",
  "step1Img": "HowItWorkSection-module__YBUagW__step1Img",
  "stepContainer": "HowItWorkSection-module__YBUagW__stepContainer",
  "stepContainerExpanded": "HowItWorkSection-module__YBUagW__stepContainerExpanded",
  "stepContainerWrapper": "HowItWorkSection-module__YBUagW__stepContainerWrapper",
  "stepCount": "HowItWorkSection-module__YBUagW__stepCount",
  "stickyWrapper": "HowItWorkSection-module__YBUagW__stickyWrapper",
  "tabsContainer": "HowItWorkSection-module__YBUagW__tabsContainer",
  "textContainer": "HowItWorkSection-module__YBUagW__textContainer",
});
